// Mock data for First Assembly Living Waters

export const churchInfo = {
  name: "First Assembly Living Waters",
  shortName: "Living Waters",
  denomination: "Assemblies of God",
  city: "Big Spring, TX",
  address: "310 W 4th St, Big Spring, TX 79720, USA",
  phone: "(325) 436-4573",
  phoneRaw: "3254364573",
  email: "pastor@firstassemblylivingwaters.org",
  pastors: "Pastors Hershel & Lacie Clay",
  facebook: "https://www.facebook.com/firstassemblylivingwaters",
  youtube: "https://www.youtube.com/@firstassemblylivingwaters/playlists",
  telegram: "https://t.me/lwprayers",
  donateUrl:
    "https://www.zeffy.com/en-US/donation-form/tithes-and-offerings-first-assembly-living-waters-big-spring-tx",
  tagline: "A river of life flowing through West Texas.",
};

export const services = [
  { day: "Sunday", name: "Sunday School", time: "9:45 \u2013 10:30 AM" },
  { day: "Sunday", name: "Worship Service", time: "10:45 AM" },
  { day: "Wednesday", name: "Mid-Week Service", time: "7:00 PM", note: "Children\u2019s Church too!" },
];

export const ministries = [
  {
    slug: "sunday-worship",
    title: "Sunday Worship",
    desc: "Spirit-filled worship, biblical preaching, and a warm welcome for every family.",
    icon: "Church",
    hero: "https://images.unsplash.com/photo-1520857014576-2c4f4c972b57?crop=entropy&cs=srgb&fm=jpg&q=85",
    tagline: "Come thirsty. Leave full.",
    verse: { text: "Let us come before His presence with thanksgiving; let us make a joyful noise to Him with psalms.", reference: "Psalm 95:2" },
    when: "Sundays at 10:45 AM (Sunday School 9:45 AM)",
    where: "Main Sanctuary",
    whoFor: "Every age, every background. Whether you\u2019ve walked with Jesus for decades or you\u2019re just exploring faith for the first time \u2014 there\u2019s a seat for you.",
    whatToExpect: [
      "A welcome and brief announcements \u2014 we keep it warm, never pushy.",
      "Heartfelt worship led by our team (15\u201320 minutes of songs, both contemporary and hymns).",
      "Prayer for anyone who wants it.",
      "A Scripture-rooted message from Pastor Hershel or Pastor Lacie Clay (30\u201335 minutes).",
      "A closing invitation to respond \u2014 no pressure, just open doors.",
    ],
    dressCode: "Come as you are \u2014 jeans, Sunday best, boots, anything goes.",
    cta: { label: "Plan Your Visit", href: "/#visit" },
  },
  {
    slug: "childrens-church",
    title: "Children\u2019s Church",
    desc: "A safe, joyful place where kids encounter Jesus through stories, songs, and play.",
    icon: "Baby",
    hero: "https://images.unsplash.com/photo-1478147427282-58a87a120781?crop=entropy&cs=srgb&fm=jpg&q=85",
    tagline: "Raising the next generation of world-changers.",
    verse: { text: "Let the little children come to Me, and do not forbid them; for of such is the kingdom of heaven.", reference: "Matthew 19:14" },
    when: "Sundays at 10:45 AM \u00b7 Wednesdays at 7:00 PM",
    where: "Kids\u2019 Wing (right off the main lobby)",
    whoFor: "Kids ages 3\u201311. Nursery care is available for little ones under 3.",
    whatToExpect: [
      "A safe, clean, cheerful space with trained and background-checked volunteers.",
      "Bible stories told in ways kids actually love \u2014 crafts, songs, games, skits.",
      "Age-appropriate worship and prayer.",
      "A simple take-home page each week so families can keep the conversation going.",
    ],
    dressCode: "Come ready to play \u2014 don\u2019t stress about clothes.",
    cta: { label: "Bring Your Kids This Sunday", href: "/#visit" },
  },
  {
    slug: "youth-ministry",
    title: "Youth Ministry",
    desc: "Equipping the next generation to live boldly, love deeply, and follow Christ.",
    icon: "Sparkles",
    hero: "https://images.unsplash.com/photo-1699974627415-1f3c5387af51?crop=entropy&cs=srgb&fm=jpg&q=85",
    tagline: "Real faith. Real friendships. Real talk.",
    verse: { text: "Let no one despise your youth, but be an example to the believers in word, in conduct, in love, in spirit, in faith, in purity.", reference: "1 Timothy 4:12" },
    when: "Wednesdays at 7:00 PM",
    where: "Youth Room \u00b7 occasional offsite events",
    whoFor: "Students in grades 6\u201312. Friends welcome \u2014 always.",
    whatToExpect: [
      "Free snacks (yes, always).",
      "Worship that actually moves you \u2014 not watered down.",
      "Honest, real-life Bible teaching that speaks to what teens are actually facing.",
      "Small group time to talk, pray, and be known.",
      "Games, events, camps, and retreats throughout the year.",
    ],
    dressCode: "Whatever you\u2019re in. Just show up.",
    cta: { label: "Message Our Youth Pastor", href: "mailto:pastor@firstassemblylivingwaters.org" },
  },
  {
    slug: "prayer-chain",
    title: "Prayer Chain",
    desc: "A 24/7 community lifting one another up. Join us on Telegram for live updates.",
    icon: "HeartHandshake",
    hero: "https://images.unsplash.com/photo-1580243152089-98da42694285?crop=entropy&cs=srgb&fm=jpg&q=85",
    tagline: "When you pray, you\u2019re never praying alone.",
    verse: { text: "The effective, fervent prayer of a righteous man avails much.", reference: "James 5:16" },
    when: "Around the clock \u2014 updates sent as requests come in",
    where: "Telegram group + in-person intercession meetings",
    whoFor: "Anyone who believes prayer changes things. No experience required.",
    whatToExpect: [
      "A private Telegram group where prayer requests are shared (respectfully and anonymously when needed).",
      "Real-time updates so you can stand in the gap when someone needs it most.",
      "A community that celebrates with you when God answers.",
    ],
    dressCode: "",
    cta: { label: "Join Our Telegram Prayer Chain", href: "https://t.me/lwprayers" },
  },
  {
    slug: "community-outreach",
    title: "Community Outreach",
    desc: "Serving Big Spring with compassion \u2014 because faith without works is dead.",
    icon: "Users",
    hero: "https://images.pexels.com/photos/32801779/pexels-photo-32801779.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tagline: "Big Spring is our mission field.",
    verse: { text: "Let your light so shine before men, that they may see your good works and glorify your Father in heaven.", reference: "Matthew 5:16" },
    when: "Ongoing \u2014 monthly events, seasonal drives",
    where: "Across Big Spring and Howard County",
    whoFor: "Anyone with willing hands. Families, teens, seniors \u2014 all welcome.",
    whatToExpect: [
      "Food pantry partnerships and grocery drives.",
      "Back-to-school backpack giveaways and Christmas Angel Tree.",
      "Neighborhood prayer walks and block parties.",
      "Care packages for local first responders and teachers.",
      "Opportunities to serve at Comanche Trail Park events.",
    ],
    dressCode: "Comfortable, weather-appropriate clothes.",
    cta: { label: "Volunteer With Us", href: "mailto:pastor@firstassemblylivingwaters.org" },
  },
  {
    slug: "bible-study",
    title: "Bible Study",
    desc: "Wednesday evenings: dig deep into Scripture and grow together in truth.",
    icon: "BookOpen",
    hero: "https://images.unsplash.com/photo-1579975096649-e773152b04cb?crop=entropy&cs=srgb&fm=jpg&q=85",
    tagline: "The Word, unpacked. Life, transformed.",
    verse: { text: "Your word is a lamp to my feet and a light to my path.", reference: "Psalm 119:105" },
    when: "Wednesdays at 7:00 PM",
    where: "Main Sanctuary",
    whoFor: "Everyone hungry for more of God\u2019s Word \u2014 new believers and lifelong disciples alike.",
    whatToExpect: [
      "Verse-by-verse teaching through books of the Bible.",
      "Space to ask real questions \u2014 nothing is off-limits.",
      "Round-table discussion and personal application.",
      "Prayer for the week ahead.",
      "A community that shows up for each other between Sundays.",
    ],
    dressCode: "Casual. Bring a Bible \u2014 or use ours.",
    cta: { label: "Join Us This Wednesday", href: "/#visit" },
  },
];

export const beliefs = [
  { n: "01", title: "The Scriptures Inspired", short: "The Bible is the verbally inspired, infallible Word of God \u2014 our authoritative rule of faith and conduct." },
  { n: "02", title: "The One True God", short: "One God revealed eternally as Father, Son, and Holy Spirit \u2014 Creator of heaven and earth." },
  { n: "03", title: "The Deity of the Lord Jesus Christ", short: "Jesus is the eternal Son of God \u2014 virgin born, sinless, crucified, risen, and exalted." },
  { n: "04", title: "The Fall of Man", short: "Man was created upright but fell by transgression, incurring physical and spiritual death." },
  { n: "05", title: "The Salvation of Man", short: "Salvation comes through repentance and faith in Jesus Christ \u2014 by grace, not works." },
  { n: "06", title: "The Ordinances of the Church", short: "Water baptism by immersion and Holy Communion as commanded by Scripture." },
  { n: "07", title: "The Baptism in the Holy Spirit", short: "Believers are empowered for life and service through the promised baptism in the Holy Spirit." },
  { n: "08", title: "Initial Physical Evidence", short: "Speaking in other tongues as the Spirit gives utterance is the initial sign of Spirit baptism." },
  { n: "09", title: "Sanctification", short: "Separation from evil and dedication to God \u2014 a life of holiness empowered by the Spirit." },
  { n: "10", title: "The Church and Its Mission", short: "To evangelize the world, worship God, build the body, and demonstrate His love." },
  { n: "11", title: "The Ministry", short: "A divinely called ministry leading the Church in evangelism, worship, building, and compassion." },
  { n: "12", title: "Divine Healing", short: "Healing is provided in the atonement and is the privilege of every believer." },
  { n: "13", title: "The Blessed Hope", short: "The imminent return of Christ for His Church \u2014 our living, blessed hope." },
  { n: "14", title: "The Millennial Reign of Christ", short: "Christ will visibly return with His saints to reign on the earth for one thousand years." },
  { n: "15", title: "The Final Judgment", short: "A final judgment in which all are judged according to their works before the throne." },
  { n: "16", title: "The New Heavens and New Earth", short: "We look for new heavens and a new earth wherein dwelleth righteousness." },
];

export const sermons = [
  {
    id: "s1",
    title: "BABEL: The Danger of Building Without God",
    speaker: "Pastor Hershel Clay",
    date: "July 7, 2025",
    youtubeId: "C4d6QdDu0F0",
    series: "Foundations",
  },
  {
    id: "s2",
    title: "The Heartbeat of the Spirit",
    speaker: "Pastor Hershel Clay",
    date: "June 23, 2025",
    youtubeId: "iCIqqiMaeNE",
    series: "Spirit & Truth",
  },
  {
    id: "s3",
    title: "Living Waters: Rivers That Never Run Dry",
    speaker: "Pastor Hershel Clay",
    date: "June 9, 2025",
    youtubeId: "dQw4w9WgXcQ",
    series: "Living Waters",
  },
  {
    id: "s4",
    title: "Faith That Moves Mountains",
    speaker: "Pastor Hershel Clay",
    date: "May 26, 2025",
    youtubeId: "3JZ_D3ELwOQ",
    series: "Foundations",
  },
];

export const galleryImages = [
  "https://images.unsplash.com/photo-1579975096649-e773152b04cb?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1580243152089-98da42694285?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1478147427282-58a87a120781?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1699974627415-1f3c5387af51?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.pexels.com/photos/34504326/pexels-photo-34504326.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/32801779/pexels-photo-32801779.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/13899687/pexels-photo-13899687.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1520857014576-2c4f4c972b57?crop=entropy&cs=srgb&fm=jpg&q=85",
];

export const heroImage =
  "https://images.unsplash.com/photo-1581589329842-a5c69e03540b?crop=entropy&cs=srgb&fm=jpg&q=85";
export const aboutImage =
  "https://images.unsplash.com/photo-1552997200-4eb4441f0852?crop=entropy&cs=srgb&fm=jpg&q=85";

export const verseOfTheWeek = {
  text: "Whosoever drinketh of the water that I shall give him shall never thirst; but the water that I shall give him shall be in him a well of water springing up into everlasting life.",
  reference: "John 4:14",
};

export const upcomingEvents = [
  { title: "Sunday Worship", date: "Every Sunday", time: "10:45 AM", location: "Sanctuary" },
  { title: "Wednesday Bible Study", date: "Every Wednesday", time: "7:00 PM", location: "Sanctuary" },
  { title: "Community Prayer Night", date: "July 25", time: "6:30 PM", location: "Fellowship Hall" },
  { title: "Family Picnic", date: "August 9", time: "12:00 PM", location: "Comanche Trail Park" },
];
